module.exports = __webpack_public_path__ + "static/media/Bitmap@2x(1).084541c1.png";